export const STI_JOURNEY_CONFIG_LESS_THAN_3_WEEKS = [
  [
    {
      title: 'Day of Exposure',
      actions: [],
    },
  ],
  [
    {
      title: '1st Consultation*',
      actions: [
        {
          icon: 'labs',
          text: 'Get tested',
        },
        {
          icon: 'medication',
          text: 'Get medicines',
        },
      ],
    },
    {
      title: 'Once Test Reports are Ready**',
      actions: [
        {
          icon: 'description',
          text: 'Your report will be explained',
        },
      ],
      info: "Certain STIs can take weeks/months to show up in tests. It's advised to complete the next steps in this treatment journey.",
    },
  ],
  [
    {
      title: "Day 21 (3 week's) From Exposure",
      actions: [
        {
          icon: 'labs',
          text: 'Get tested',
        },
      ],
    },
    {
      title: 'Once Test Reports are Ready**',
      actions: [
        {
          icon: 'description',
          text: 'Your report will be explained',
        },
      ],
    },
  ],
  [
    {
      title: '3 Months from Exposure',
      actions: [
        {
          icon: 'labs',
          text: 'Get tested',
        },
      ],
    },
    {
      title: 'Once Test Reports are Ready**',
      actions: [
        {
          icon: 'description',
          text: 'Your report will be explained',
        },
      ],
    },
  ],
];

export const STI_JOURNEY_CONFIG_MORE_THAN_3_WEEKS = [
  [
    {
      title: 'Day of Exposure',
      actions: [],
    },
  ],
  [
    {
      title: '1st Consultation*',
      actions: [
        {
          icon: 'labs',
          text: 'Get tested',
        },
        {
          icon: 'medication',
          text: 'Get medicines',
        },
      ],
    },
    {
      title: 'Once Test Reports are Ready**',
      actions: [
        {
          icon: 'description',
          text: 'Your report will be explained',
        },
      ],
      info: "Certain STIs can take weeks/months to show up in tests. It's advised to complete the next steps in this treatment journey.",
    },
  ],
  [
    {
      title: '3 Months from Exposure',
      actions: [
        {
          icon: 'labs',
          text: 'Get tested',
        },
      ],
    },
    {
      title: 'Once Test Reports are Ready**',
      actions: [
        {
          icon: 'description',
          text: 'Your report will be explained',
        },
      ],
    },
  ],
];

export enum StiExposureTime {
  LESS_THAN_3_DAYS = 'Less than 3 Days (<72 hours)',
  BETWEEN_3_AND_21_DAYS = '3 Days to 21 Days',
  MORE_THAN_21_DAYS = 'More than 21 Days',
}

export const STI_JOURNEY_ROLLOUT_USERS = [
  'c2e5f76a-68ca-48b0-9b1a-07b049a4b805',
  'c3638406-1df4-49ba-820d-8eea502b66c0',
];

export const DRUG_WEIGHT = 0.3;
export const DRUG_PICKUP_PINCODE = 560_102;
